import { useEffect } from 'react';
import PropTypes from 'prop-types';
import screenTypeTelemetry from '../screenTypeTelemetry';
import { applyDataPropTypes } from '../../../applyFlowPropTypes';
import { FINALIZE_APPLY } from '../../../screenTypeSchema';


export function FinalizeApply({
  applyData,
  onScreenTypeFinish,
  screenTypeObject,
}) {
  useEffect(() => {
    function handleApplyFlowFinish() {
      if (typeof applyData.onDone === 'function') {
        // if apply flow is complete, the status will always be "delivered"
        applyData.onDone(screenTypeObject.application_state);
      }
      if (applyData.redirectAfterApply || screenTypeObject.data.force_redirect) {
        // TODO: JSD-1173 If no action_url, log an error and redirect
        const redirectUrl = screenTypeObject.action_url ?? `/apply/next-action/${encodeURIComponent(applyData.encryptedQuizId)}`;
        window.location.assign(redirectUrl);
      }
      onScreenTypeFinish();
    }

    const { logInteraction } = screenTypeTelemetry(FINALIZE_APPLY, applyData);
    logInteraction('continue');
    handleApplyFlowFinish();
    return null;
  });

  return null;
}

FinalizeApply.propTypes = {
  applyData: applyDataPropTypes.isRequired,
  onScreenTypeFinish: PropTypes.func.isRequired,
  screenTypeObject: PropTypes.shape(PropTypes.any), // eslint-disable-line react/forbid-prop-types
};

FinalizeApply.defaultProps = {
  screenTypeObject: {},
};

export default FinalizeApply;
